// reactstrap components
import {
  Container,
  Row,
} from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import Demographics from "../../../components/Demographics.js"

const DemographicView = () => {
  return (
    <>
      <Header 
        title="Demographics"
        description="Survey Demographics"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Demographics />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default DemographicView;